module.exports = __webpack_public_path__ + "assets/7cd0b126696962358f3cc694f778d555.mp4";